module.exports = __webpack_public_path__ + "static/media/DSC_0274.c8f08a58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0274.jpg
// module id = 573
// module chunks = 0